export default __webpack_public_path__ + "static/media/icaew_m1.bc4da8f1.png";